import React, { Fragment } from "react";
import {
  TabContent,
  TabPane,
  Nav,
  NavItem,
  NavLink,
  Row,
  Label,
  Input,
  Alert,
} from "reactstrap";
import { Table, Thead, Tbody, Tr, Th, Td } from "react-super-responsive-table";
import Navbarh from "../navbar/Navbar";
import "../estilos.css";
import * as IoIcons from "react-icons/io";
import Pagination from "react-js-pagination";
import Moment from "moment";
import classnames from "classnames";
import Locaciones from "./Locaciones";
import useAlmacen from "../../hooks/useAlmacen";
import EtiquetaRAC from "../reciba/EtiquetaRAC";

function Almacen() {
  const {
    ppalmacenDInventario,
    ppalmacenMEmbarcado,
    ppalmacen,
    vpreciounitario,
    formType,
    color,
    aVisible,
    mensajeAlert,
    cargando,
    activeTab,
    searchBy,
    search,
    reciba,
    currentPage,
    recordPerPage,
    totalRecords,
    pageRange,
    mRecibas,
    inputList,
    userName,
    vistaNumeroParte,
    locaciones,
    clicDescargarDatos,
    marcarEmbarcado,
    marcarEmbarcadoReciba,
    marcarFueradePlanta,
    onDismiss,
    palmacen,
    toggle1,
    buscarpor,
    setSearch,
    onSearchFecha,
    handlePageChange,
    onSearch,
    onChangescheckVUAP,
    onChangescheckVNP,
    fetchAlmacen,
    obtenerUltimaUbicaciont,
    cliclMostrar,
    managelocacion
  } = useAlmacen();
  return (
    <>
      <Navbarh />
      {ppalmacen === true && (
        <>
          <Row>
            <div className="headerp col-lg-12 col-md-12 col-sm-12 col-xs-12">
              <IoIcons.IoMdFiling
                className="iconoc floatleft"
                onClick={palmacen}
              />
              <h3>{formType}</h3>
            </div>
          </Row>
          <div className="conteiner3">
            <Alert color={color} isOpen={aVisible} toggle={onDismiss}>
              {mensajeAlert}
            </Alert>
            {cargando === true && (
              <Row>
                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 ">
                  <img
                    width="150px"
                    alt="cargando"
                    src="assets/img/preloader.gif"
                  />
                </div>
              </Row>
            )}

            {formType === "Almacén" && (
              <Fragment>
                <Nav tabs>
                  <NavItem>
                    <NavLink
                      className={classnames({ active: activeTab === "1" })}
                      onClick={() => {
                        toggle1("1");
                      }}
                    >
                      Almacén
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      className={classnames({ active: activeTab === "2" })}
                      onClick={() => {
                        toggle1("2");
                      }}
                    >
                      Locaciones
                    </NavLink>
                  </NavItem>
                </Nav>
                <TabContent activeTab={activeTab}>
                  <TabPane tabId="1">
                    <Row className="ml-1 mr-1">
                      <div class="col-lg-5 col-md-5 col-sm-12 col-xs-12 text-left  margintopmobil20px">
                        <Label>
                          <h5>Busqueda por: </h5>
                        </Label>
                        <select
                          name="recibabusqueda"
                          className="ml-2"
                          onChange={buscarpor}
                        >
                          <option value="cliente" selected={searchBy === 'cliente' ? true : false}>Cliente</option>
                          <option value="paking" selected={searchBy === 'paking' ? true : false}>Packing</option>
                          <option value="numero de parte" selected={searchBy === 'numero de parte' ? true : false}>
                            Número de parte
                          </option>
                          <option value="lote" selected={searchBy === 'lote' ? true : false}>Lote</option>
                          <option value="fecha" selected={searchBy === 'fecha' ? true : false}>Fecha</option>
                          <option value="serial" selected={searchBy === 'serial' ? true : false}>Serial</option>
                          <option value="serial BTI" selected={searchBy === 'serial BTI' ? true : false}>Serial BTI</option>
                          <option value="id de reciba" selected={searchBy === 'id de reciba' ? true : false}>ID de Reciba</option>
                        </select>
                        <Input
                          type={searchBy !== "fecha" ? "text" : "date"}
                          placeholder={"Búsqueda por " + searchBy}
                          onChange={
                            searchBy !== "fecha"
                              ? (e) => setSearch(e.target.value)
                              : onSearchFecha
                          }
                          onKeyUp={searchBy !== "fecha" ? onSearch : ""}
                          value={search}
                        />
                      </div>
                      <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12 text-left  margintop20px">
                        {ppalmacenDInventario === true && (
                          <button
                            class="btn-warning cbutton floatrightleft ml-2"
                            title="Descargar datos a excel"
                            onClick={() => clicDescargarDatos("descarga")}
                          >
                            <IoIcons.IoIosDownload /> Descargar datos
                          </button>
                        )}
                        {userName === "GLACIA.PALACIOS" && ( // && Moment(now).format("YYYY-MM-DD") === "2023-01-02 userName === "CHRISTIAN.HERNANDEZ"
                          <button
                            className="cbutton btn-danger floatright  mr-3 marginrightmobil3p "
                            title="Marcar material como embarcado"
                            onClick={() => {
                              marcarEmbarcado();
                            }}
                          >
                            <IoIcons.IoIosAnalytics /> Marcar embarcado
                          </button>
                        )}
                      </div>
                      <div class="col-lg-3 col-md-3 col-sm-12 col-xs-12 text-left  margintop20px">
                        <button
                          className="cbutton btn-dark floatrightleft  "
                          title="Recargar página"
                          onClick={() => {
                            fetchAlmacen();
                          }}
                        >
                          <IoIcons.IoMdRefresh /> Recargar
                        </button>
                      </div>
                    </Row>
                    <Row>
                      <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12 text-left  margintop10px">
                        <Label className="floatleft"><input type="checkbox" name="chkVNP" onChange={onChangescheckVNP} className='ml-2' />Vista por número de parte</Label>
                      </div>
                      <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12 text-center  margintop10px">
                        <Label className="floatleft ml-2 "> Días en planta: </Label>
                        <Label className="floatleft ml-2 bcolorlb">{"de 3 a 7"}</Label>
                        <Label className="floatleft ml-2 bcolorbb ">{"de 8 a 15"}</Label>
                        <Label className="floatleft ml-2 bcolorr"> {"más de 15"}</Label>
                      </div>
                      <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12 text-right  margintop10px">
                        <Label className="floatrightleft mr-3">
                          <input
                            type="checkbox"
                            name="VUAP"
                            onChange={onChangescheckVUAP}
                            className="ml-2"
                          />
                          Vista del último al primero
                        </Label>
                      </div>
                    </Row>

                    <div className=" col-lg-12 col-md-12 col-sm-12 col-xs-12 scroll">
                      <Table className="mb-2 scroll ">
                        <Thead class="thead-secondary">
                          <Tr>
                            <Th className="minwidth80px">{vistaNumeroParte === false ? " ID" : "Número"}</Th>
                            <Th>Cliente</Th>
                            <Th className={vistaNumeroParte === true ? " displaynone" : "minwidth80px"}>
                              Fecha y hora de reciba
                            </Th>
                            <Th className={vistaNumeroParte === true ? " displaynone" : "minwidth80px"}>
                              Días en planta
                            </Th>
                            <Th>Estatus </Th>
                            <Th className={vistaNumeroParte === true ? " displaynone" : ""}>Packing </Th>
                            <Th>Número de parte</Th>
                            <Th className={vpreciounitario === false ? " displaynone" : "minwidth100px"}>Precio unitario</Th>
                            <Th className={vpreciounitario === false ? " displaynone" : "minwidth100px"}>Costo en inventario</Th>
                            <Th className={vistaNumeroParte === true ? " displaynone" : ""}>Lote</Th>
                            <Th className={vistaNumeroParte === true ? " displaynone" : ""}>Proceso</Th>
                            <Th className={vistaNumeroParte === true ? " displaynone" : "minwidth100px"}>Serial </Th>
                            <Th className={vistaNumeroParte === true ? " displaynone" : "minwidth100px"}>Serial BTI </Th>
                            <Th className={vistaNumeroParte === true ? " displaynone" : "minwidth100px"}>Locación </Th>
                            <Th className={vistaNumeroParte === false ? " displaynone" : "minwidth100px"}>Cantidad recibida </Th>
                            <Th className={vistaNumeroParte === false ? " displaynone" : "minwidth100px"}>Cantidad Planeada </Th>
                            <Th className={vistaNumeroParte === false ? " displaynone" : "minwidth100px"}>Cantidad en almacén </Th>
                            <Th className={vistaNumeroParte === true ? " displaynone" : ""}>Última ubicación</Th>
                            <Th className={vistaNumeroParte === true ? " displaynone" : "width30px"}> Acciones </Th>
                          </Tr>
                        </Thead>
                        <Tbody>
                          {reciba.map((recibas, i) => (
                            <Tr className={(recibas.FEPlanta >= 3 && recibas.FEPlanta <= 7) ? "bcolorlb" :
                              (recibas.FEPlanta >= 8 && recibas.FEPlanta <= 15) ? "bcolorbb" :
                                (recibas.FEPlanta > 15) ? "bcolorr" :
                                  i % 2 !== 0 ? "table-active" : ""}>
                              <Td>{vistaNumeroParte === false ? recibas.numero : i + 1}</Td>
                              <Td>{recibas.cliente}</Td>
                              <Td className={vistaNumeroParte === true ? " displaynone" : "margintopmobil20px"}>
                                {recibas.fechayHoraDeReciba}
                              </Td>
                              <Td className={vistaNumeroParte === true ? " displaynone" : "margintopmobil20px"}>
                                {recibas.FEPlanta}
                              </Td>
                              <Td className="margintopmobil20px">
                                {recibas.status}
                              </Td>
                              <Td className={vistaNumeroParte === true ? " displaynone" : "margintopmobil20px"}>
                                {recibas.packing}
                              </Td>
                              <Td className="margintopmobil20px">
                                {recibas.numerodeParte}
                              </Td>
                              <Td className={vpreciounitario === false ? " displaynone" : "margintopmobil20px"}>
                                {((recibas.divisa === "Peso mexicano" || recibas.divisa === "Dólar") ? "$" : "€") + " " + recibas.precioUnitario}
                              </Td>
                              <Td className={vpreciounitario === false ? " displaynone" : "margintopmobil20px"}>
                                {((recibas.divisa === "Peso mexicano" || recibas.divisa === "Dólar") ? "$" : "€") + " " + (recibas.precioUnitario * recibas.piezasenAlmacen).toFixed(2)}
                              </Td>
                              <Td className={vistaNumeroParte === true ? " displaynone" : "margintopmobil20px"}>
                                {recibas.lote}
                              </Td>
                              <Td className="margintopmobil20px">
                                <Label>{(recibas.Ecoat === true || (!recibas.Ecoat && recibas.precioUnitario)) ? "Ecoat" : ""}</Label>
                                <br></br>
                                <Label className="margintop20px">{recibas.Pcoat === true ? " Powder coat" : ""}</Label>
                                {/*<Label className="margintop20px">{recibas.Platinado === true ? " Platinado" : ""}</Label>*/}
                              </Td>
                              <Td className={vistaNumeroParte === true ? " displaynone" : "margintopmobil20px"}>
                                {recibas.serial}
                              </Td>
                              <Td className={vistaNumeroParte === true ? " displaynone" : "margintopmobil20px"}>
                                {recibas.serialRecibaBTI}
                              </Td>
                              <Td className={vistaNumeroParte === true ? " displaynone" : "margintopmobil20px"}>
                                <select
                                  name="locacion"
                                  className=" custom-select"
                                  onChange={(e) => managelocacion(recibas, recibas.locacion, e.target.value, e.target.name, i, reciba, 1)}>
                                  {recibas.locacion !== "" && (
                                    <option
                                      className=""
                                      value={recibas.locacion}
                                      selected="true">
                                      {recibas.locacion}{" "}
                                    </option>
                                  )}
                                  <option
                                    className=""
                                    value=""
                                    selected={
                                      recibas.locacion === "" ? true : false
                                    }>
                                    Elige
                                  </option>
                                  {locaciones.map((locacion, i) => (
                                    <>
                                      <option
                                        className=""
                                        value={locacion.locacion}
                                        selected={recibas.locacion === locacion.locacion ? true : false}
                                      >
                                        {locacion.locacion}
                                      </option>
                                    </>
                                  ))}
                                </select>
                              </Td>
                              <Td className={vistaNumeroParte === false ? " displaynone" : "margintopmobil20px"}>
                                {recibas.cantidadRecibida}
                              </Td>
                              <Td className={vistaNumeroParte === false ? " displaynone" : "margintopmobil20px"}>
                                {recibas.cantidadPlaneada}
                              </Td>
                              <Td className={vistaNumeroParte === false ? " displaynone" : "margintopmobil20px"}>
                                {recibas.piezasenAlmacen}
                              </Td>
                              <Td className={vistaNumeroParte === true ? " displaynone" : "margintopmobil20px"}>
                                {obtenerUltimaUbicaciont(
                                  recibas.ultimaUbicacion
                                )}
                              </Td>
                              <Td className={vistaNumeroParte === true ? " displaynone" : "margintopmobil40px"}>
                                <button
                                  class="btn-info cbutton mt-1 ml-1"
                                  onClick={() => cliclMostrar(recibas)}
                                  title="Detalles de reciba"
                                >
                                  {" "}
                                  <IoIcons.IoIosListBox />{" "}
                                </button>
                                <button
                                  className={(vistaNumeroParte === true || ppalmacenMEmbarcado === false) ? " displaynone btn-danger cbutton mt-1 ml-1" : "btn-danger cbutton mt-1 ml-1"}
                                  onClick={() => marcarFueradePlanta(recibas)}
                                  title="Marcar material fuera de planta"
                                >
                                  <IoIcons.IoIosAnalytics />{" "}
                                </button>
                              </Td>
                            </Tr>
                          ))}
                        </Tbody>
                      </Table>
                    </div>
                    <div className="mt-3 mb-3">
                      Página {currentPage}, mostrando del{" "}
                      {recordPerPage * currentPage - recordPerPage + 1} al{" "}
                      {totalRecords < recordPerPage * currentPage
                        ? totalRecords
                        : recordPerPage * currentPage}{" "}
                      de {totalRecords} registros
                    </div>
                    {/*<div className=" col-lg-12 col-md-12 col-sm-12 col-xs-12 " style={{ marginTop: 20 }}>{JSON.stringify(recibaSinFiltro)}</div>*/}
                    <Row>
                      <div className="col-lg-12 col-md-12 col-sm-12  ">
                        <div className="floatcenter">
                          <Pagination
                            itemClass="page-item" // add it for bootstrap 4
                            linkClass="page-link" // add it for bootstrap 4
                            activePage={currentPage}
                            itemsCountPerPage={recordPerPage}
                            totalItemsCount={totalRecords}
                            pageRangeDisplayed={pageRange}
                            onChange={handlePageChange}
                          />
                        </div>
                      </div>
                    </Row>
                  </TabPane>
                  <TabPane tabId="2">
                    <Locaciones />
                  </TabPane>
                </TabContent>
              </Fragment>
            )}
          </div>
          <div className="conteiner2">
            {formType === "Detalle Reciba " + mRecibas.numero && (
              <Fragment>
                <Row>
                  <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                    <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6 floatleft"></div>
                    <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6 floatright">
                      <button
                        class="btn-info cbutton floatright"
                        onClick={palmacen}
                        title="Regresar"
                      >
                        <IoIcons.IoMdArrowRoundBack />
                        Regresar{" "}
                      </button>
                    </div>
                  </div>
                  <div className=" col-lg-12 col-md-12 col-sm-12 col-xs-12 margintop20px scroll">
                    <div className="textaligmentleft">
                      {" "}
                      <h5>Datos generales</h5>
                    </div>
                    <Table className="margintop20px mb-2  ">
                      <Thead class="thead-secondary">
                        <Tr>
                          <Th>ID</Th>
                          <Th>Cliente</Th>
                          <Th className="minwidth80px">
                            Fecha y hora de reciba
                          </Th>
                          <Th>Cantidad por reciba</Th>
                          <Th>Status</Th>
                          <Th> Quien Inspeccionó </Th>
                          <Th> Comentarios de inspección </Th>
                          <Th> PO </Th>
                        </Tr>
                      </Thead>
                      <Tbody>
                        <Tr>
                          <Td>{mRecibas.numero}</Td>
                          <Td>{mRecibas.cliente}</Td>
                          <Td className="margintopmobil20px">
                            {Moment(mRecibas.fechaDeReciba).format(
                              "DD/MM/YYYY"
                            ) +
                              " " +
                              mRecibas.horaDeReciba}
                          </Td>
                          <Td className="margintopmobil20px">
                            {mRecibas.cantidadRecibida}
                          </Td>
                          <Td className="margintopmobil20px">
                            {mRecibas.status}
                          </Td>
                          <Td className="margintopmobil20px">
                            {mRecibas.quienInspecciono}
                          </Td>
                          <Td className="margintopmobil20px">
                            {mRecibas.comentarios}
                          </Td>
                          <Td className="margintopmobil20px">{mRecibas.po}</Td>
                        </Tr>
                      </Tbody>
                    </Table>
                  </div>
                  <div className=" col-lg-12 col-md-12 col-sm-12 col-xs-12 scroll margintop20px">
                    <div className="textaligmentleft">
                      {" "}
                      <h5>Detalle</h5>{" "}
                    </div>
                    <Table className=" mb-2">
                      <Thead class="thead-secondary">
                        <Tr>
                          <Th>
                            {" "}
                            {mRecibas.cliente ===
                              "Olson Internacional, S. de R.l. de C.v"
                              ? "Line"
                              : "Packing"}
                          </Th>
                          <Th>Número de parte</Th>
                          <Th>Descripción</Th>
                          <Th>Material en</Th>
                          <Th>Empaques</Th>
                          <Th>Proceso</Th>
                          <Th>Lote</Th>
                          <Th>Serial</Th>
                          <Th>Serial BTI</Th>
                          <Th>Cantidad por serial</Th>
                          <Th>Estatus</Th>
                          <Th>Última ubicación</Th>
                          <Th>Quién Inspeccionó</Th>
                          <Th>Comentarios</Th>
                          <Th>Imprimir Etiqueta</Th>
                        </Tr>
                      </Thead>
                      <Tbody>
                        {inputList.map((x, i) => {
                          return (
                            x.activo && (
                              <Tr class={x.sombreado ? "table-primary" : ""}>
                                <Td className="margintopmobil20px">
                                  {x.packing}
                                </Td>
                                <Td className="margintopmobil20px">
                                  {x.numerodeParte}
                                </Td>
                                <Td className="margintopmobil20px">
                                  {x.descripcion}
                                </Td>
                                <Td className="margintopmobil20px">
                                  {x.materialEn}
                                </Td>
                                <Td className="margintopmobil20px">
                                  {x.materialEnCantidad}
                                </Td>
                                <Td className="margintopmobil20px">
                                  <Label>{(x.Ecoat === true || (!x.Ecoat && x.precioUnitario)) ? "Ecoat" : ""}</Label>
                                  <Label className="mt-1">{x.Pcoat === true ? "Powder coat" : ""}</Label>
                                  {/*<Label className="mt-1">{x.Platinado === true ? "Platinado" : ""}</Label>*/}
                                </Td>
                                <Td className="margintopmobil20px">{x.lote}</Td>
                                <Td className="margintopmobil20px">
                                  {x.serial}
                                </Td>
                                <Td className="margintopmobil20px">
                                  {x.serialRecibaBTI}
                                </Td>
                                <Td className="margintopmobil20px">
                                  {x.cantidadRecibida}
                                </Td>
                                <Td className="margintopmobil20px">
                                  {x.status}
                                </Td>
                                <Td className="margintopmobil20px">
                                  {obtenerUltimaUbicaciont(x.ultimaUbicacion)}
                                </Td>
                                <Td className="margintopmobil20px">
                                  {x.quienInspecciono}
                                </Td>
                                <Td className="margintopmobil20px">
                                  {x.comentariosdeinspeccion}
                                </Td>
                                <Td className="margintopmobil20px mb-4">
                                  {(x.piezasenAlmacen ? x.piezasenAlmacen : 0) >
                                    0 && (
                                      <EtiquetaRAC
                                        indice={i}
                                        inputList={inputList}
                                        mRecibas={mRecibas}
                                        tipo={"parcial"}
                                        bColor={"dark mt-1 ml-1"}
                                        btitle={"Etiqueta viajera - Cuarentena"}
                                        llamada={"Almacén"}
                                      />
                                    )}
                                </Td>
                              </Tr>
                            )
                          );
                        })}
                      </Tbody>
                    </Table>
                  </div>
                  {/*<div  className=" col-lg-12 col-md-12 col-sm-12 col-xs-12 " style={{ marginTop: 20 }}>{JSON.stringify(inputListUbicaciones)}</div>*/}
                </Row>
              </Fragment>
            )}
          </div>
        </>
      )}
    </>
  );
}

export default Almacen;
